import { IRateModel } from "./rates.model";

// Shared between Project Sampling and Measure Sampling: the ratetype string is also the FormControl key.
export enum RateType {
  COMPLIANT = "compliant",
  PARTIAL_COMPLIANT = "partiallycompliant",
  NON_COMPLIANT = "noncompliant",
  EXCLUSION = "noncompliantexclusion",
}

// Ratetypes zeroed out at the project level, per overread stage.
export interface IDisabledRateTypes {
  OR1: RateType[];
  OR2: RateType[];
}

export interface IOverreadModel {
  mrqa: {
    rates: {
      rate: IRateModel[];
    };
  };
  overread: {
    rates: {
      rate: IRateModel[];
    };
  };
  overread2: {
    rates: {
      rate: IRateModel[];
    };
  };
}
